import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const SupplyContext = createContext(undefined);

const initialInvoices = [
  {
    id: "INV-240001",
    invoiceNumber: "RE-240001",
    supplierName: "Bosch Automotive Aftermarket",
    importSource: "TecCom",
    invoiceDate: "2024-05-05",
    dueDate: "2024-06-04",
    amount: 1166,
    currency: "EUR",
    purchaseOrderNumber: "PO-2024-101",
    goodsReceiptNumber: "GR-2024-088",
    lastUpdated: "2024-05-05T06:32:00Z",
    lines: [
      {
        id: "10",
        position: "10",
        itemNumber: "0 986 580 115",
        description: "Bremssattel hinten rechts",
        orderedQty: 2,
        receivedQty: 2,
        invoicedQty: 2,
        unit: "Stk",
        orderedPrice: 210.5,
        invoicedPrice: 210.5,
        matchStatus: "MATCH",
        deviation: null,
        resolution: { status: "MATCHED" },
        history: [
          {
            action: "AUTO_CHECK",
            user: "System",
            timestamp: "2024-05-05T06:32:00Z",
            note: "3-Way-Match ohne Abweichung.",
          },
        ],
      },
      {
        id: "20",
        position: "20",
        itemNumber: "0 986 479 141",
        description: "Bremsbelagsatz Vorderachse",
        orderedQty: 8,
        receivedQty: 8,
        invoicedQty: 10,
        unit: "Satz",
        orderedPrice: 58.9,
        invoicedPrice: 58.9,
        matchStatus: "QUANTITY_DEVIATION",
        deviation: {
          type: "Mengenabweichung",
          description: "Rechnung weist 2 Sätze mehr aus als Wareneingang.",
          difference: "+2",
        },
        resolution: { status: "PENDING" },
        history: [
          {
            action: "AUTO_CHECK",
            user: "System",
            timestamp: "2024-05-05T06:32:00Z",
            note: "Mengenabweichung: Rechnung 10, Wareneingang 8.",
          },
        ],
      },
      {
        id: "30",
        position: "30",
        itemNumber: "1 457 433 084",
        description: "Ölfilter",
        orderedQty: 12,
        receivedQty: 12,
        invoicedQty: 12,
        unit: "Stk",
        orderedPrice: 12.5,
        invoicedPrice: 13,
        matchStatus: "PRICE_DEVIATION",
        deviation: {
          type: "Preisabweichung",
          description: "Rechnungspreis 13,00 EUR, Bestellung 12,50 EUR.",
          difference: "+0,50 EUR",
        },
        resolution: { status: "PENDING" },
        history: [
          {
            action: "AUTO_CHECK",
            user: "System",
            timestamp: "2024-05-05T06:32:00Z",
            note: "Preisabweichung: Bestellung 12,50 EUR, Rechnung 13,00 EUR.",
          },
        ],
      },
    ],
  },
  {
    id: "INV-240002",
    invoiceNumber: "RE-240054",
    supplierName: "ZF Friedrichshafen",
    importSource: "Manuell",
    invoiceDate: "2024-05-07",
    dueDate: "2024-06-06",
    amount: 864.8,
    currency: "EUR",
    purchaseOrderNumber: "PO-2024-099",
    goodsReceiptNumber: "GR-2024-091",
    lastUpdated: "2024-05-07T10:12:00Z",
    lines: [
      {
        id: "10",
        position: "10",
        itemNumber: "0501.235.987",
        description: "Kupplungssatz",
        orderedQty: 3,
        receivedQty: 3,
        invoicedQty: 3,
        unit: "Satz",
        orderedPrice: 220,
        invoicedPrice: 220,
        matchStatus: "MATCH",
        deviation: null,
        resolution: { status: "MATCHED" },
        history: [
          {
            action: "AUTO_CHECK",
            user: "System",
            timestamp: "2024-05-07T10:12:00Z",
            note: "3-Way-Match ohne Abweichung.",
          },
        ],
      },
      {
        id: "20",
        position: "20",
        itemNumber: "0501.875.332",
        description: "Lenkgetriebe",
        orderedQty: 1,
        receivedQty: 1,
        invoicedQty: 1,
        unit: "Stk",
        orderedPrice: 420,
        invoicedPrice: 450,
        matchStatus: "PRICE_DEVIATION",
        deviation: {
          type: "Preisabweichung",
          description: "Rechnungspreis 450,00 EUR, Bestellung 420,00 EUR.",
          difference: "+30,00 EUR",
        },
        resolution: {
          status: "IN_CLARIFICATION",
          user: "Maria Klein",
          timestamp: "2024-05-07T12:20:00Z",
          note: "Preis laut Rahmenvertrag 420 EUR, Rückfrage beim Lieferanten offen.",
        },
        history: [
          {
            action: "AUTO_CHECK",
            user: "System",
            timestamp: "2024-05-07T10:12:00Z",
            note: "Preisabweichung: Bestellung 420,00 EUR, Rechnung 450,00 EUR.",
          },
          {
            action: "IN_CLARIFICATION",
            user: "Maria Klein",
            timestamp: "2024-05-07T12:20:00Z",
            note: "Preis laut Rahmenvertrag 420 EUR, Rückfrage beim Lieferanten offen.",
          },
        ],
      },
    ],
  },
  {
    id: "INV-240003",
    invoiceNumber: "RE-240075",
    supplierName: "HELLA GmbH",
    importSource: "TecCom",
    invoiceDate: "2024-05-09",
    dueDate: "2024-06-08",
    amount: 542.4,
    currency: "EUR",
    purchaseOrderNumber: "PO-2024-107",
    goodsReceiptNumber: "GR-2024-094",
    lastUpdated: "2024-05-09T08:44:00Z",
    lines: [
      {
        id: "10",
        position: "10",
        itemNumber: "1A6 355 860-001",
        description: "LED-Scheinwerfereinsatz",
        orderedQty: 4,
        receivedQty: 4,
        invoicedQty: 4,
        unit: "Stk",
        orderedPrice: 135.6,
        invoicedPrice: 135.6,
        matchStatus: "MATCH",
        deviation: null,
        resolution: { status: "MATCHED" },
        history: [
          {
            action: "AUTO_CHECK",
            user: "System",
            timestamp: "2024-05-09T08:44:00Z",
            note: "3-Way-Match ohne Abweichung.",
          },
        ],
      },
    ],
  },
];

function computeInvoiceStatus(lines) {
  const deviatingLines = lines.filter((line) => line.matchStatus !== "MATCH");
  if (deviatingLines.length === 0) {
    return "Automatisch geprüft";
  }

  const allAccepted = deviatingLines.every(
    (line) => line.resolution && line.resolution.status === "ACCEPTED"
  );

  if (allAccepted) {
    return "Abgeschlossen";
  }

  const hasClarification = deviatingLines.some(
    (line) => line.resolution && line.resolution.status === "IN_CLARIFICATION"
  );

  if (hasClarification) {
    return "In Klärung";
  }

  return "Offen";
}

export function SupplyProvider({ children }) {
  const [vehicle, setVehicle] = useState(null);
  const [basket, setBasket] = useState(null);
  const [offers, setOffers] = useState([]);
  const [invoices, setInvoices] = useState(() =>
    initialInvoices.map((invoice) => ({
      ...invoice,
      status: computeInvoiceStatus(invoice.lines),
    }))
  );

  const updateInvoiceLine = useCallback((invoiceId, lineId, transformer, meta = {}) => {
    setInvoices((prevInvoices) =>
      prevInvoices.map((invoice) => {
        if (invoice.id !== invoiceId) {
          return invoice;
        }

        const updatedLines = invoice.lines.map((line) =>
          line.id === lineId ? transformer(line) : line
        );

        return {
          ...invoice,
          lines: updatedLines,
          status: computeInvoiceStatus(updatedLines),
          lastUpdated: meta.timestamp ?? invoice.lastUpdated,
        };
      })
    );
  }, []);

  const acceptInvoiceDeviation = useCallback((invoiceId, lineId, { user, note }) => {
    const timestamp = new Date().toISOString();

    updateInvoiceLine(
      invoiceId,
      lineId,
      (line) => {
        const historyEntry = {
          action: "ACCEPTED",
          user,
          timestamp,
          note: note ?? null,
        };

        return {
          ...line,
          resolution: {
            status: "ACCEPTED",
            user,
            timestamp,
            note: note ?? null,
          },
          history: [...(line.history ?? []), historyEntry],
        };
      },
      { timestamp }
    );
  }, [updateInvoiceLine]);

  const requestInvoiceClarification = useCallback((invoiceId, lineId, { user, note }) => {
    const timestamp = new Date().toISOString();

    updateInvoiceLine(
      invoiceId,
      lineId,
      (line) => {
        const historyEntry = {
          action: "IN_CLARIFICATION",
          user,
          timestamp,
          note: note ?? null,
        };

        return {
          ...line,
          resolution: {
            status: "IN_CLARIFICATION",
            user,
            timestamp,
            note: note ?? null,
          },
          history: [...(line.history ?? []), historyEntry],
        };
      },
      { timestamp }
    );
  }, [updateInvoiceLine]);

  const value = useMemo(
    () => ({
      vehicle,
      setVehicle,
      basket,
      setBasket,
      offers,
      setOffers,
      invoices,
      acceptInvoiceDeviation,
      requestInvoiceClarification,
    }),
    [
      vehicle,
      basket,
      offers,
      invoices,
      acceptInvoiceDeviation,
      requestInvoiceClarification,
    ]
  );

  return <SupplyContext.Provider value={value}>{children}</SupplyContext.Provider>;
}

export function useSupply() {
  const context = useContext(SupplyContext);
  if (!context) {
    throw new Error("useSupply must be used within a SupplyProvider");
  }
  return context;
}
